import { render, staticRenderFns } from "./PaChiefIndex.vue?vue&type=template&id=321898cd&scoped=true"
import script from "./PaChiefIndex.vue?vue&type=script&lang=js"
export * from "./PaChiefIndex.vue?vue&type=script&lang=js"
import style0 from "./PaChiefIndex.vue?vue&type=style&index=0&id=321898cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321898cd",
  null
  
)

export default component.exports